import type { IIconProps } from '@app/components/Icon/types'
import type React from 'react'

interface IIconIoeEntraIdProps extends IIconProps {}

const IconIoeEntraId: React.FC<IIconIoeEntraIdProps> = props => {
  const size = props.size ?? 20

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5 10.5L8 14.5L1.5 10.5M14.5 8.5L8 12.5L1.5 8.5L8 1.5L14.5 8.5Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default IconIoeEntraId
